import { render, staticRenderFns } from "./select-input.vue?vue&type=template&id=d8b38998&scoped=true"
import script from "./select-input.vue?vue&type=script&lang=js"
export * from "./select-input.vue?vue&type=script&lang=js"
import style0 from "./select-input.vue?vue&type=style&index=0&id=d8b38998&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b38998",
  null
  
)

export default component.exports